import { useState } from 'react';
import { api } from '../lib/api.js';

// Tally launcher (Phase A, 2026-07-12). Tally is the inventory/COGS app —
// a separate service fronted by Monarch's identity. This view exists
// because opening it is a full-page navigation that needs a signed handoff
// (see server/features/tally/proxy-routes.js); the button fetches a 60s
// token and opens /tally/ in a new tab, already signed in.
export function TallyLaunchView({ user }) {
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function open() {
    setBusy(true); setErr('');
    try {
      const r = await api('POST', '/api/tally/handoff', {}, { 'x-user-id': String(user.id) });
      window.open(r.url, '_blank', 'noopener');
    } catch (e) {
      let m = e.message; try { m = JSON.parse(e.message).error; } catch {}
      setErr(m || 'Could not open Tally.');
    } finally { setBusy(false); }
  }

  return (
    <div className="card" style={{ maxWidth: 520 }}>
      <div className="text-base font-semibold mb-1">Tally</div>
      <div className="text-sm text-gray-500 mb-4">
        Inventory, ordering, and recipe costs. Order suggestions come from real
        usage; deliveries get received here; weekly counts keep on-hand honest.
        Opens in a new tab — you're already signed in.
      </div>
      <button className="btn-primary" onClick={open} disabled={busy}>
        {busy ? 'Opening…' : 'Open Tally →'}
      </button>
      {err && <div className="text-xs text-red-700 mt-3">{err}</div>}
    </div>
  );
}
